import { cn } from '@utils/helpers'

export const Card = ({
  children,
  title,
  icon,
  className = '',
  padding = 'p-4',
  variant = 'default',
  onClick,
  ...props
}) => {
  const isStats = variant === 'stats'

  return (
    <div
      className={cn(
        'card',
        padding,
        onClick && 'cursor-pointer hover:scale-[1.01] transition-transform',
        className
      )}
      onClick={onClick}
      {...props}
    >
      {isStats ? (
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1">
            {children}
          </div>
          {icon && (
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center shrink-0 shadow-sm">
              {icon}
            </div>
          )}
        </div>
      ) : (
        <>
          {(title || icon) && (
            <div className="flex items-center justify-between mb-3">
              {title && <h4 className="font-semibold text-slate-900">{title}</h4>}
              {icon && (
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center shrink-0">
                  {icon}
                </div>
              )}
            </div>
          )}
          <div className="text-sm text-slate-600">
            {children}
          </div>
        </>
      )}
    </div>
  )
}

/**
 * Card with title and optional header actions
 * Migrated from shared/Card.jsx
 */
export const CardWithTitle = ({ title, children, actions, className = '' }) => {
  return (
    <div className={cn('card p-6', className)}>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-slate-900">{title}</h2>
        {actions && <div className="flex gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  )
}

/**
 * Empty state card
 * Migrated from shared/Card.jsx
 */
export const EmptyStateCard = ({ message, description, icon, action }) => {
  return (
    <div className="card p-6">
      <div className="text-center py-12 text-slate-600">
        {icon && <div className="mb-4">{icon}</div>}
        <p className="text-lg font-medium text-slate-600 mb-1">{message}</p>
        {description && <p className="text-sm text-slate-400">{description}</p>}
        {action && <div className="mt-4">{action}</div>}
      </div>
    </div>
  )
}
